export default __webpack_public_path__ + "static/media/dash-linkedin.ca50bede.svg";